export const AGENT_LEFT = 'agent_left'
export const AGENT_JOINED = 'agent_joined'
export const END_CONVERSATION = 'end_conversation'
export const SESSION_EXPIRED = 'session_expired'
